import SVGProps from 'src/components/icons/config/svg-props' //
// Auto-generated file created by svgr-cli source svg-template.cjs
// Run npm run generate-icons to update
// Do not edit
const SvgImportIcon = (props: SVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    fill="none"
    viewBox="0 0 64 64"
    role="img"
    className="icon"
    {...props}
  >
    <path
      fill="currentColor"
      d="M30.4 38.4h-.864l-9.122-10.641-2.43 2.082 9.122 10.642a3.2 3.2 0 0 0 2.43 1.117h4.928a3.2 3.2 0 0 0 2.43-1.117l9.12-10.642-2.43-2.082-9.12 10.641H33.6V9.6h-3.2zM9.6 48v-9.6h3.2V48a3.2 3.2 0 0 0 3.2 3.2h32a3.2 3.2 0 0 0 3.2-3.2v-9.6h3.2V48a6.4 6.4 0 0 1-6.4 6.4H16A6.4 6.4 0 0 1 9.6 48"
    />
  </svg>
)
export default SvgImportIcon
